module.exports = __webpack_public_path__ + "static/media/bg.935391cd.jpg";